"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpTableDropdownFilter = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_bootstrap_1 = require("react-bootstrap");
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = require("../Icon/Icon");
var DpTableDropdownFilter_styled_1 = require("./DpTableDropdownFilter.styled");
var accessibility_helper_1 = require("../../../api/helpers/accessibility.helper");
var DpTableDropdownFilter = function (_a) {
    var options = _a.options, disabled = _a.disabled, placeholder = _a.placeholder, styles = _a.styles, selectHandler = _a.selectHandler;
    // ------------------------------ State
    var _b = (0, react_1.useState)(false), open = _b[0], setOpen = _b[1];
    var _c = (0, react_1.useState)(placeholder), buttonLabel = _c[0], setButtonLabel = _c[1];
    // -------------------------------- Methods
    var setButtonLabelText = (0, react_1.useCallback)(function (selectedOptions) {
        var label = placeholder;
        if (selectedOptions.length > 0) {
            label = selectedOptions[0].title;
        }
        setButtonLabel(label);
    }, [setButtonLabel, placeholder]);
    var getSelectedOptions = (0, react_1.useCallback)(function () { return options.filter(function (option) { return option.selected; }); }, [options]);
    var toggle = function () { return setOpen(!open); };
    var close = function () { return setOpen(false); };
    (0, react_1.useEffect)(function () {
        setButtonLabelText(getSelectedOptions());
    }, [options, setButtonLabelText, getSelectedOptions]);
    // --------------------------------- Render
    var createListItems = function () {
        return options.map(function (option) {
            var handleItemClick = function (e) {
                toggle();
                setButtonLabel(option.title);
                selectHandler(option);
            };
            return ((0, jsx_runtime_1.jsx)("li", { role: "menuitem", tabIndex: -1, onClick: handleItemClick, className: (0, classnames_1.default)('dropdown-item', { active: option.selected }), onKeyDown: (0, accessibility_helper_1.handleButtonPress)(handleItemClick), children: option.title }, option.id));
        });
    };
    return ((0, jsx_runtime_1.jsxs)(DpTableDropdownFilter_styled_1.StyledDropdown, { show: open, onToggle: close, className: (0, classnames_1.default)(styles), children: [(0, jsx_runtime_1.jsxs)(react_bootstrap_1.Dropdown.Toggle, { id: "filter-dropdown", disabled: disabled, variant: "outline-primary", onClick: toggle, children: [(0, jsx_runtime_1.jsx)("span", { children: buttonLabel }), (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: open ? 'chevron-up' : 'chevron-down', className: "" })] }), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Dropdown.Menu, { as: "ul", role: "menu", children: createListItems() })] }));
};
exports.DpTableDropdownFilter = DpTableDropdownFilter;
